var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"total-center pa-4"},[_c('div',[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":85,"width":3}}),_c('div',{staticClass:"bigger-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }